<template>
  <div class="gameDeatil_page">
    <div class="gdlp_1">
      <div class="gdlp_1_1">
        <img class="gdlp_1_12" width="180px" height="180px" :src="icon" />
        <p class="gdlp_1_13">{{ name }}</p>
        <div class="gdlp_1_14">
          <div class="gdlp_1_141" v-html="testList[0]"></div>
          <div class="gdlp_1_142">{{ grade }}</div>
        </div>
      </div>
    </div>
    <div class="gdlp_2">
      <gameDetail
        :createTime="createTime"
        :developers="developers"
        :types="types"
        :description="description"
        :images="images"
        :fileUrl="fileUrl"
        :name="name"
        :langType="langType"
      ></gameDetail>
    </div>
    <div class="gdlp_3">
      <p class="gdlp_3_1" v-html="testList[4]"></p>
      <div class="gdlp_3_2">
        <router-link
          :to="'/gameDetailPage/' + item.id"
          v-for="item in everyonePlays"
          :key="item.id"
          class="gdlp_321"
        >
          <img width="120px" height="120px" :src="item.icon" />
          <p>{{ item.name }}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import gameDetail from "./component/gameDetail";
export default {
  name: "gameDeatil_page",
  props: {
  },
  watch: {
    '$i18n.locale'(newValue) {
      this.changeLang(newValue);
      this.getEveryonePlay(newValue);
      this.getGameDetail(this.$route.params["id"],newValue);
    },
    // langType: {
    //   handler(newVal,oldVal){
    //     console.log(newVal)
    //     this.changeLang(newVal);
    //   },
    //   deep:true,
    //   immediate: true
    // },
    // 监听路由没变，参数发生变化
    $route(to, from) {
      //监听路由是否变化
      if (to.params.id != from.params.id) {
        this.status = to.query.status;
        this.$router.go(0)
      }
    },
  },
  components: {
    gameDetail,
  },
  created() {
    // this.getEveryonePlay(this.$i18n.locale);
    // this.getGameDetail(this.$route.params["id"],this.$i18n.locale);
    // this.changeLang(this.$i18n.locale);
  },
  mounted() {
    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.getEveryonePlay('zh')
      this.getGameDetail(this.$route.params["id"],'zh')
      this.changeLang('zh')
    }else{
      this.getEveryonePlay('en')
      this.getGameDetail(this.$route.params["id"],'en')
      this.changeLang('en')
    }
  },
  updated() {},
  methods: {
    getEveryonePlay(language) {
      this.$post("/halababy/loofox/game", { type: 0, num: 12 }).then((res) => {
        let games = new Array();
        for (let i = 0; i < res.data.length; i++) {
          let game = {
            id: res.data[i]["id"],
            name: res.data[i]["name"],
            icon: this.$ip + res.data[i]["icon"],
          };
          if(language == 'en'){
            game.name = res.data[i]["nameEn"]
          }
          games.push(game);
        }
        this.everyonePlays = games;
      });
    },
    getGameDetail(id,language) {
      this.$post("/halababy/loofox/gamedetail", { id: id }).then((res) => {
        if(res.data['fileUrl'] == null || res.data['fileUrl'] == undefined){
          this.fileUrl = null;
        }else{
          // this.fileUrl = this.$ip + res.data['fileUrl'];
          this.fileUrl = res.data['fileUrl'];
        }
        if(language == 'zh'){
          this.name = res.data["name"];
          this.description = res.data["description"];
          this.types = res.data["types"].split("|");
        }else{
          this.name = res.data["nameEn"];
          this.description = res.data["descriptionEn"];
          this.types = res.data["typesEn"].split("|");
        }
        this.grade = res.data["grade"];
        this.icon = this.$ip + res.data["icon"];
        this.developers = res.data["developers"];
        this.createTime = res.data["createTime"];
        let imgs = new Array();
        for (let i = 0; i < res.data["imgList"].length; i++) {
          let img = this.$ip + res.data["imgList"][i];
          imgs.push(img);
        }
        this.images = imgs;
      });
    },
    changeLang(type) {
      this.$post("/halababy/loofox/text", { pageNum: 12 }).then((res) => {
        if (type == "zh") {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
        } else {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
        }
        this.langType = type;
      });
    },
  },
  props: {
    id: String,
  },
  data() {
    return {
      testList:[],
      everyonePlays: this.everyonePlays,
      gamed: this.gamed,
      name: this.name,
      grade: this.grade,
      types: this.types,
      icon: this.icon,
      description: this.description,
      developers: this.developers,
      createTime: this.createTime,
      images: this.images,
      fileUrl:this.fileUrl,
      langType: this.langType,
    };
  },
};
</script>

<style>
.gameDeatil_page {
  width: 100%;
  padding-bottom: 70px;
  text-align: left;
  background-color: rgba(246, 246, 246, 1);
}
.gdlp_1 {
  width: 100%;
  height: 300px;
  background: url("../assets/gd/detail1.png") no-repeat;
  margin: auto;
}
.gdlp_1_12 {
  border-radius: 40px;
}
.gdlp_1_1 {
  width: 1200px;
  padding-top: 100px;
  margin: auto;
  display: flex;
  align-items: center;
}
.gdlp_1_13 {
  margin-left: 30px;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
}
.gdlp_1_14 {
  width: 122px;
  height: 40px;
  display: flex;
  background-image: url("../assets/gd/detail3.png");
  margin-left: 30px;
}
.gdlp_1_14 div {
  width: 61px;
  text-align: center;
  line-height: 40px;
}
.gdlp_1_141 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.gdlp_1_142 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #181818;
}
.gdlp_2 {
  width: 1200px;
  padding-top: 20px;
  margin: auto;
}
.gdlp_3 {
  width: 1200px;
  background-color: white;
  margin: 40px auto 0 auto;
}
.gdlp_3_1 {
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
  padding-top: 40px;
  padding-left: 40px;
}
.gdlp_3_2 {
  margin: auto;
  display: flex;
  width: 1140px;
  /* justify-content: space-between; */
  flex-flow: wrap;
  padding-bottom: 80px;

}

.gdlp_321 {
  width: 190px;
  height: 150px;
  margin-top: 30px;
  text-align: center;
  cursor: pointer;
  display: block;
  text-decoration: none;
}
.gdlp_321 img{
  border-radius: 20px;
}
.gdlp_321 p {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
  text-align: center;
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/gameDetailPage.vue